import React from 'react';
import { Spacing } from '../../design-system/spacing';
import {
  currencyFormatterInteger,
  numberFormatter,
} from '../../utils/number-formatter';
import { styled } from '../../utils/styled';
import { Card } from '../Card';
import { PercentageBar } from '../PercentageBar';
import { Stack } from '../Stack';
import { Typography } from '../Typography';
import { getTotal } from './utils';

export const StyledCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'borderColor',
})<{ borderColor: string }>`
  padding: ${({ theme }) => theme.spacing(Spacing.Medium)};
  align-items: flex-start;
  border-radius: ${({ theme }) => theme.borderRadii.outer};
  border-left-style: solid;
  border-left-width: ${({ theme }) => theme.spacing(Spacing.Small)};
  border-left-color: ${({ borderColor }) => borderColor};
  width: 100%;
  height: 134px;
  box-shadow: ${({ theme }) => theme.boxShadows.card};
`;

const StyledContainerStack = styled(Stack)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing(Spacing.Tiny)};
  width: 100%;
`;
const StyledTypography = styled(Typography)`
  align-items: flex-end;
`;
interface CardProps {
  readonly title: string;
  readonly borderColor: string;
  readonly items: { key: string; value: number }[];
  readonly format?: 'number' | 'currency';
}

export function StatsCard({
  title,
  borderColor,
  items,
  format = 'number',
}: CardProps) {
  const totalNum = getTotal(items);
  const formatter =
    format === 'number' ? numberFormatter : currencyFormatterInteger;

  return (
    <StyledCard borderColor={borderColor}>
      <StyledContainerStack>
        <Typography variant="h5">{title}</Typography>
        <StyledTypography color="text.secondary" variant="body">
          {formatter.format(format === 'currency' ? totalNum / 100 : totalNum)}{' '}
          Total
        </StyledTypography>
      </StyledContainerStack>
      <PercentageBar format={format} items={items} />
    </StyledCard>
  );
}
